import { useEffect } from "react";
import { getDomainConfig } from "../config/domains";

const resetStaleZadarmaSession = () => {
  const match = document.cookie.match(/ZCallbackWidget=([^;]+)/);
  if (!match) return;

  try {
    const data = JSON.parse(decodeURIComponent(match[1]));
    const sessionStart = data.start || 0;
    const thirtyMinutes = 30 * 60 * 1000;

    // Скидаємо тільки якщо сесія старша за 30 хв
    if (Date.now() - sessionStart > thirtyMinutes) {
      document.cookie = "ZCallbackWidget=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "ZCallbackWidgetTmpId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  } catch {
    // Якщо cookie пошкоджений — скидаємо
    document.cookie = "ZCallbackWidget=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "ZCallbackWidgetTmpId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }
};

const injectZadarmaStyles = () => {
  const style = document.createElement("style");
  style.textContent = `
    .z-c-m__button {
      width: 80px !important;
      height: 80px !important;
    }
    @media (max-width: 768px) {
      .z-c-m__button {
        width: 60px !important;
        height: 60px !important;
      }
    }
  `;
  document.head.appendChild(style);
};

const ZadarmaWidget = () => {
  useEffect(() => {
    const domainConfig = getDomainConfig();
    const widgetId = domainConfig.zadarmaWidgetId;

    if (!widgetId) return;

    if (document.getElementById("zadarma-widget-script")) return;

    // Скидаємо стару сесію щоб очки набирались заново
    resetStaleZadarmaSession();

    // Стилі для кнопки віджета
    injectZadarmaStyles();

    const w = window as any;
    w.ZCallbackWidgetLinkId = widgetId;
    w.ZCallbackWidgetDomain = "my.zadarma.com";

    const script = document.createElement("script");
    script.id = "zadarma-widget-script";
    script.type = "text/javascript";
    script.charset = "utf-8";
    script.async = true;
    script.src =
      "https://" +
      w.ZCallbackWidgetDomain +
      "/callbackWidget/js/main.min.js?v=1.15.4";

    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  }, []);

  return null;
};

export default ZadarmaWidget;
